"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _HeaderComponent.default;
  }
});

var _HeaderComponent = _interopRequireDefault(require("./Header-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }